export const StripeTestPractice = {
    stripeTestPractice: 'CZNATsnyXXCgTG1h',
}
